import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";

import useAuth from "./useAuth";
import { useGetMyselfQuery } from "../api/loginApi";

const useLinkAccessCheck = () => {
  const { linkToken, token, linkAccessData, logout, isDemo } = useAuth();
  const { clientId, projectId, stateId } = useParams();
  const isLinkToken = !!linkToken;
  const isToken = !!token;

  const navigate = useNavigate();

  const { error: myselfError } = useGetMyselfQuery();

  useEffect(() => {
    if (myselfError && !isDemo) {
      logout();
      navigate("/login");
    }
  }, [myselfError, isDemo, logout, navigate]);

  if (!isToken) {
    if (
      !isLinkToken ||
      !linkAccessData ||
      (linkAccessData.clientId && linkAccessData.clientId !== clientId) ||
      (linkAccessData.projectId && linkAccessData.projectId !== projectId) ||
      (linkAccessData.stateId && linkAccessData.stateId !== stateId)
    ) {
      // redirect to login
      navigate("/login");
    }
  }
};

export default useLinkAccessCheck;
